const isShowReadMoreText = (ref: any, numberOfLines: number): boolean => {
  const style = window.getComputedStyle(ref.current);
  const { lineHeight } = style;
  const maxHeight = parseFloat(lineHeight) * numberOfLines;
  const divHeight = ref.current.offsetHeight;
  return divHeight > maxHeight;
};

export default isShowReadMoreText;
